module.exports = __webpack_public_path__ + "static/media/CivilandCommercalLitigation.4aa6e895.jpg";